export default __webpack_public_path__ + "static/media/nav_image_9.c4c99150.jpg";